import { add as addRequest } from 'serviceWorker/db/httpRequests';
import {
  HttpRequestModelType,
  HttpRequestStatus,
} from 'shared/domain/httpRequest/httpRequestModel';
import { CreateChecklistItemsOutDto } from 'shared/dtos/out/template';
import { InspectionTemplateChecklistItemsHttpCreateRequestModel } from '../httpQueue/inspectionTemplate/types';

export class InspectionTemplateChecklistItemsCreator {
  constructor(
    private addRequest: (
      request: InspectionTemplateChecklistItemsHttpCreateRequestModel
    ) => Promise<unknown>
  ) {}

  async execute(
    templateId: string,
    checklistItemsOutDto: CreateChecklistItemsOutDto,
    projectId: string,
    uniqueId: string
  ): Promise<void> {
    await this.addRequest({
      createdAt: Date.now(),
      method: 'POST',
      data: {
        checklistItemsOutDto,
        uniqueId,
      },
      url: `/project/${projectId}/inspectionTemplate/${templateId}/checklistItem`,
      entityType: HttpRequestModelType.inspectionTemplate,
      status: HttpRequestStatus.NEW,
    });
  }
}

export const inspectionTemplateChecklistItemsCreator =
  new InspectionTemplateChecklistItemsCreator(addRequest);
